import React, { useMemo, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import ButtonAceptar from './ButtonAceptar'
import IconCloseModal from './IconCloseModal'
import { Row, Col, InputGroup, Label, Input, FormGroup } from "reactstrap"

import  "assets/scss/Components/Modals/ModalIngresarObservacion.scss"

//assets/scss/Modals/ModalIngresarObservacion.scss
type PropsModalMensaje = {
    show: boolean,
    size: "xl" | "sm" | "md" | "lg",
    onClose: () => void,
    tituloModal: string,

    mensajeHtml: React.ReactElement | undefined
    centered: boolean,
    asyncOnClick: (observacion: string) => Promise<number>;
    classNameContentModal?: string,
    classNameAllModal?: string
}


type ModalIngresarObservacionState = {
    observacion: string,
    loading: boolean
}


export default function ModalIngresarObservacion(props: PropsModalMensaje) {

    const initialState: ModalIngresarObservacionState = {
        loading: false,
        observacion: ""
    }

    const [modalState, setmodalState] = useState<ModalIngresarObservacionState>(initialState)


    async function AccionModal(observacion: string, callbackAccion: (observacion: string) => Promise<number>) {
        setmodalState({ ...modalState, loading: true })

        await callbackAccion(observacion);
        setmodalState({ ...modalState, loading: false })
    }

    const BotonCerrar = useMemo(() => {
        return (
            <IconCloseModal
                handleClickIcon={() => {
                    props.onClose();
                    setmodalState(initialState)
                }}
            />
        )
    }
        , [props])


    return (
        <Modal
            isOpen={props.show}
            scrollable={true}
            size={props.size}
            fullscreen={props.size}
            centered={props.centered}
            onClosed={() => props.onClose()}
            contentClassName={(props.classNameAllModal ?? "custom-modal-style") === "default" ? "" : props.classNameAllModal}
        >
            <ModalHeader close={BotonCerrar}>
                <div className='tituloModalDocumentos'>{props.tituloModal}</div>
            </ModalHeader>
            <ModalBody>
                {
                    props.mensajeHtml !== undefined &&
                    props.mensajeHtml
                }

                <Row>
                    <Col md={12}>
                        <form>
                            <FormGroup>
                                <Label id="labelObservacionMIO">{"Ingrese su observación"}</Label>
                                <Input
                                    type={"textarea"}
                                    value={modalState.observacion}
                                    onChange={(e) => setmodalState({ ...modalState, observacion: e.target.value })}
                                    className="textareanotfocus"
                                />
                            </FormGroup>
                        </form>
                        {/* <InputGroup>
                            
                                
                        </InputGroup> */}
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <ButtonAceptar
                    handleClickAceptar={() => AccionModal(modalState.observacion, props.asyncOnClick)}
                    //disabled = {modalState.observacion === ""}
                    nombreBoton={'Enviar observación'}
                />
            </ModalFooter>
        </Modal>
    )
}
